import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';

const GenreBreakdownModal = ({ onClose }) => {
  const [genres, setGenres] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/stats/genre-breakdown?status=played').then(data => {
      setGenres(data.genres || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const colors = ['#f97316', '#a855f7', '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#ec4899', '#fb923c', '#8b5cf6', '#14b8a6'];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(20px) saturate(180%)', WebkitBackdropFilter: 'blur(20px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: `linear-gradient(145deg, ${THEME.bgElevated}, ${THEME.bgCard})`, borderRadius: '20px', padding: '24px', width: '95%', maxWidth: '450px', maxHeight: '85vh', overflow: 'auto', border: `1px solid ${THEME.border}`, boxShadow: `0 25px 80px ${THEME.shadowHeavy}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '20px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>🎮</span> Genre Breakdown
          </h2>
          <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', borderRadius: '8px', padding: '8px 12px', color: THEME.textMuted, cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ color: THEME.textMuted, fontSize: '13px', marginBottom: '16px' }}>Genres of your played games</p>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
        ) : genres.length === 0 ? (
          <div style={{ textAlign: 'center', color: THEME.textMuted, padding: '40px' }}>No genre data available</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {genres.map((genre, idx) => (
              <div key={genre.name} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: colors[idx % colors.length] }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span style={{ color: THEME.text, fontSize: '13px', fontWeight: '500' }}>{genre.name}</span>
                    <span style={{ color: THEME.textMuted, fontSize: '12px' }}>{genre.count} ({genre.percentage}%)</span>
                  </div>
                  <div style={{ height: '6px', background: THEME.bg, borderRadius: '3px', overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: `${genre.percentage}%`, background: colors[idx % colors.length], borderRadius: '3px' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GenreBreakdownModal;
